import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useCategories } from 'application/hooks/useCategories';
import { useImportWizardStore } from '../../store/useImportWizardStore';

/**
 * Category selector using Autocomplete for consistent styling.
 * Populated from useCategories hook (stageCategories).
 */
const CategorySelector: React.FC = () => {
  const { categories } = useCategories();
  const categoryID = useImportWizardStore(
    (s) => s.mappingConfig.categoryID ?? ''
  );
  const updateMappingConfig = useImportWizardStore(
    (s) => s.updateMappingConfig
  );

  const selectedCategory =
    categories.find((cat) => cat.id === categoryID) || null;

  return (
    <Autocomplete
      id="category-select"
      options={categories}
      getOptionLabel={(option) => option.title || ''}
      value={selectedCategory}
      onChange={(_event, newValue) => {
        updateMappingConfig({ categoryID: newValue?.id || '' });
      }}
      renderInput={(params) => (
        <TextField {...params} label="Category" size="small" />
      )}
      ListboxProps={{
        style: { maxHeight: 200 },
      }}
      sx={{ maxWidth: 400 }}
      openOnFocus
      size="small"
      fullWidth
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};

export default CategorySelector;
